import { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex/AdminFormPage";
import QuoteForm from "../common/QuoteForm/QuoteForm";
import { Quote } from "../types/Quote";

function New({
  project_id,
  account,
  permissions,
  project,
  revenueCalculationLabel,
  labels,
}) {
  const navigate = useNavigate();
  const submitRef = useRef<any>();
  const [quote, setQuote] = useState<Quote>({
    id: "0",
    description: "",
    oneTimeCost: "0.0",
    oneTimeRevenue: "0.0",
    markup: "",
    mrrMarkup: "",
    recurringCost: "0.0",
    recurringRevenue: "0.0",
    billingFrequency: {
      value: "one_time",
      label: "No",
    },
    billingMethod: {
      value: "time_and_materials",
      label: "Time and Materials",
    },
  });

  const canSave =
    permissions.quotes !== "view" &&
    project?.data?.attributes?.status === "building";

  const extraActions = canSave && (
    <>
      <Button
        className="btnSeawhite"
        onClick={() => {
          submitRef.current?.saveQuote(true);
        }}
      >
        Save and Add Another
      </Button>
      <Button
        className="squareGreenButton"
        onClick={() => {
          submitRef.current?.saveQuote(false);
        }}
      >
        Save
      </Button>
    </>
  );

  return (
    <AdminFormPage
      title={`Add ${labels.quote}`}
      onCancel={() =>
        navigate(`/projects/${project_id}/quotes`, { state: null })
      }
      extraActions={extraActions}
    >
      <QuoteForm
        quote={quote}
        setQuote={setQuote}
        setPreviousQuote={() => null}
        project_id={project_id}
        account={account}
        ref={submitRef}
        permissions={permissions}
        project={project}
        revenueCalculationLabel={revenueCalculationLabel}
        label={labels.quote}
      />
    </AdminFormPage>
  );
}

export default New;
